<script>

    let { children } = $props();

</script>

<div>
    {@render children?.()}
</div>

<style>

    div {
        background-color: var(--box-color);
        padding: 1.5em;
        border-radius: 8px;
    }

    div > :global(*) {
        margin: 0;
        padding: 0;
    }

</style>